import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { Colors, Height } from './scss/common/style';
import MainNavigation from './components/common/MainNavigation';
import AppRoutes from './routing/AppRoutes';
import MyContext from './services/context';
import UserLocalService from './services/logic/userService';

//https://www.telerik.com/kendo-react-ui/components/styling/
import '@progress/kendo-theme-default/dist/all.css';

import Footer from './components/common/Footer';
import ErrorsContainer from './components/common/Errors';

export default function App(): JSX.Element {
  const [user, setUser] = useState(UserLocalService.getUser());
  return (
    <>
      <Global />
      <div className="App">
        <MyContext.Provider value={{ user, setUser }}>
          <Router>
            <header>
              <MainNavigation />
            </header>
            <StyledMain className="container-fluid">
              <AppRoutes />
              <ErrorsContainer
                ref={(ref) => {
                  window.ErrorsContainer = ref;
                }}
              />
            </StyledMain>
            <StyledFooter className="container-fluid content-colorful" />
          </Router>
        </MyContext.Provider>
      </div>
    </>
  );
}

const Global = createGlobalStyle`
  html,
  body {
    padding-top: 0 !important;
    padding-right: 0 !important;
    font-size: 16px;
    font-family: 'Roboto', sans-serif;
    overflow-x: hidden !important;
  }
  
  h1,h2,h3,h4,h5,h6 {
    text-align: center;
    color: ${Colors.darkBlue};
    font-family: 'Amazing Grotesk Book', 'Roboto', sans-serif;
    text-transform: uppercase;
    &.white {
      color: white;
    }
    padding: 1.25em 0;
    font-weight: 700;
  }
`;

const StyledFooter = styled(Footer)`
  &.content-colorful {
    background-color: ${Colors.svBrown};
    min-height: ${Height.footerHeight};
    padding-top: 20px;
    h1 {
      margin-bottom: 10px;
    }
  }
`;

const StyledMain = styled.div`
  position: relative;
  &.content-colorful {
    background-color: ${Colors.svBrown};
    min-height: calc(100vh - ${Height.footerHeight});
    padding-top: 20px;
    h1 {
      margin-bottom: 10px;
    }
  }
`;
